import { localeToCountry } from 'wanderu-i18n';

import countries from './countries.json';

function getCountryLocaleConfigs(supportedLocales, currentLocale) {
    let countryConfigsKeyedByCode = supportedLocales.reduce((acc, locale) => {
        const countryCode = localeToCountry(locale);

        const {
            name: countryName,
            defaultLocale,
        } = countries[countryCode] || {};

        acc[countryCode] = {
            ...acc[countryCode],
            countryCode,
            countryName,
            defaultLocale,
            isActive: (acc[countryCode] && acc[countryCode].isActive) || currentLocale === locale,
            locales: [
                ...((acc[countryCode] && acc[countryCode].locales) || []),
                locale,
            ],
        };

        return acc;
    }, {});

    return Object.values(countryConfigsKeyedByCode).sort((a, b) => {
        return a.countryName.localeCompare(b.countryName, 'en');
    });
}

export {
    getCountryLocaleConfigs,
};

export default {
    getCountryLocaleConfigs,
};
